// extracted by mini-css-extract-plugin
export default {"wrapper":"pageLoader__wrapper-MQAMd","content":"pageLoader__content-WGCxH","logo":"pageLoader__logo-LOqeI","text":"pageLoader__text-kpu3_"};